export default defineNuxtPlugin((nuxtApp) => {
    const router = useRouter()
    router.afterEach((to) => {
        const hasExtension = /\.[a-zA-Z0-9]+$/.test(to.path)
        if (!hasExtension && to.path !== '/' && !to.path.endsWith('/')) {
            nextTick(() => {
                history.replaceState(
                    history.state,
                    '',
                    to.path + '/' + window.location.search + window.location.hash
                )
            })
        }
    })
})
